import { BackTop, ConfigProvider, Icon } from 'antd'
import enUS from 'antd/lib/locale-provider/en_US'
import FullScreenLoading from 'components/FullScreenLoading'
import React, { Component, Suspense } from 'react'
import { QueryClient, QueryClientProvider, ReactQueryDevtools } from 'react-query'
import { HashRouter, Redirect, Route, Switch } from 'react-router-dom'
import 'react-table-v6/react-table.css'
import './assets/css/sider.css'
import Newsletter from './components/Main/Newsletter/EmailRenderer/EmailRenderer'
import CenterSpin from './elements/CenterSpin'
import OfflineDetector from './elements/OfflineDetector'
import UpdateDetector from './elements/UpdateDetector'

import { GlobalProvider } from './Global'
import Authentication from './modules/Authentication'
import AsyncAdmin from './views/Admin/Layout.jsx'
import AsyncCorporate from './views/Corporate/Layout.jsx'
import AsyncFinance from './views/Finance/Layout.jsx'
import AsyncHSEQ from './views/HSEQ/Layout.jsx'

import Login from './views/Login.jsx'
import AsyncMain from './views/Main/Layout.jsx'
import AsyncOperations from './views/Operations/Layout.jsx'
import AsyncPeople from './views/People/Layout.jsx'
import AsyncProject from './views/Project/Layout.jsx'
import AsyncPurchasing from './views/Purchasing/Layout.jsx'
import AsyncClients from './views/Sales/Layout'

const queryClient = new QueryClient()

export default function AppRouter() {
  const auth = new Authentication()

  return (
    <QueryClientProvider client={queryClient}>
      <GlobalProvider>
        <FullScreenLoading>
          <div>
            <OfflineDetector />
            <UpdateDetector />
            <BackTop>
              <Icon type="up-circle" theme="filled" style={{ fontSize: 33, color: '#08c' }} />
            </BackTop>
            <ConfigProvider locale={enUS}>
              <HashRouter>
                <Suspense fallback={<CenterSpin fontSize={50} />}>
                  <Switch>
                    <PrivateRoute
                      auth={auth}
                      path="/newsletter/render/:newsletter"
                      name="newsletter"
                      component={Newsletter}
                    />
                    <AuthenticatingRoute auth={auth} path="/login" name="login" component={Login} />

                    <PrivateRoute auth={auth} path="/clients" name="clients" component={AsyncClients} />
                    <PrivateRoute auth={auth} path="/operations" name="operations" component={AsyncOperations} />
                    <PrivateRoute auth={auth} path="/purchasing" name="purchasing" component={AsyncPurchasing} />
                    <PrivateRoute auth={auth} path="/corporates" name="corporates" component={AsyncCorporate} />
                    <PrivateRoute auth={auth} path="/people" name="people" component={AsyncPeople} />
                    <PrivateRoute auth={auth} path="/finance" name="finance" component={AsyncFinance} />
                    <PrivateRoute auth={auth} path="/programs" name="program" component={AsyncProject} />
                    <PrivateRoute auth={auth} path="/hseq" name="hseq" component={AsyncHSEQ} />
                    <PrivateRoute auth={auth} path="/admin" name="admin" component={AsyncAdmin} />
                    <PrivateRoute auth={auth} path="/" name="Main" component={AsyncMain} />
                  </Switch>
                </Suspense>
              </HashRouter>
            </ConfigProvider>
          </div>
        </FullScreenLoading>
      </GlobalProvider>
    </QueryClientProvider>
  )
}

const PrivateRoute = ({ component: Component, auth, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      auth.isAuthenticated() === true ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/login',
            state: { from: props.location },
          }}
        />
      )
    }
  />
)
const AuthenticatingRoute = ({ component: Component, auth, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      auth.isAuthenticated() === true ? (
        <Redirect
          to={{
            pathname: '/',
            state: { from: props.location },
          }}
        />
      ) : (
        <Component {...props} />
      )
    }
  />
)
